import logo from "./logo.svg";
import "./App.css";
import SandboxLogin from "./Screens/SandboxLogin";
import ProposalBot from "./Screens/ProposalBot";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Dashboard from "./Screens/Dashboard";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<SandboxLogin />} />
          <Route exact path="/Dashboard" element={<Dashboard />} />
          <Route exact path="/ProposalBot" element={<ProposalBot />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
